const getMediaType = (source) => {
  if (!source) {
    return 'image/jpeg'
  }

  const path = source.split('?')[0].split('#')[0]
  const extension = path.split('.').pop()?.toLowerCase()

  if (extension === 'mp4' || extension === 'mov' || extension === 'webm') {
    return `video/${extension === 'mov' ? 'quicktime' : extension}`
  }

  return 'image/jpeg'
}

export const mapLibraryItemToMediaCard = (apiItem) => ({
  id: apiItem.id,
  url: apiItem.image_url,
  filename: apiItem.image_name,
  name: apiItem.image_name,
  created_at: apiItem.created_at ?? apiItem.date_created ?? null,
  type: getMediaType(apiItem.image_url || apiItem.image_name),
  format: apiItem.format ?? null,
  ratio: apiItem.ratio,
  width: apiItem.meta_data?.width ?? null,
  height: apiItem.meta_data?.height ?? null,
  group_id: apiItem.group_id,
  headline: apiItem.headline,
  original: apiItem.original,
  meta_data: apiItem.meta_data ?? {},
})

export const mapLibraryItemToMediaLabel = (apiItem) => ({
  variant: apiItem.original ? 'uploaded-variants' : 'generated',
  ...(apiItem.total_variations !== null ? { variantsCount: apiItem.total_variations } : {}),
})

export const mapLibraryItem = (apiItem) => ({
  item: mapLibraryItemToMediaCard(apiItem),
  mediaLabel: mapLibraryItemToMediaLabel(apiItem),
})

export const mapLibraryItems = (apiItems = []) => apiItems.map(mapLibraryItem)
